export class OrderDialogOrderItemDto {
  orderItemId: number;
  menuItemId: number;
  productId: number;
  productName: string;
  quantity: number;
  price: number;
  modifiers: OrderDialogOrderModifierItem[];
}

export class OrderDialogOrderModifierItem {
  modifierId: number;
  modifierName: string;
  quantity: number;
  price: number;
}